import { HeadingTagType as LexicalHeadigTagType } from '@lexical/rich-text';

export type HeadingTagType = LexicalHeadigTagType;

enum HeadingTagTypeEnum {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6',
}

export const HEADING_TAGS: readonly HeadingTagType[] = [
  HeadingTagTypeEnum.H1,
  HeadingTagTypeEnum.H2,
  HeadingTagTypeEnum.H3,
  HeadingTagTypeEnum.H4,
  HeadingTagTypeEnum.H5,
  HeadingTagTypeEnum.H6,
];
